// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2f83y","cell":"ColumnAccessor_cell__OphGX","firstCellAccent":"ColumnAccessor_firstCellAccent__OA5rE"};